import React from 'react'
import {TitleWrapper, Title, DescWrapper, DescriptionText} from './style'

const SmallTitle = ({props}) => {
    return (
        <>
        <TitleWrapper solo={props.solo}>
        <Title {...props}>
            {props.text}
        </Title>
        {!props.solo ? <DescWrapper left={props.left}>
                        <DescriptionText size={props.desc_font_size}>
                        {props.description}
                        </DescriptionText>
                        </DescWrapper> : ''}
        </TitleWrapper>
        </>
    )
}

export default SmallTitle
